import { useAppSelector } from "store";
import styled from "@emotion/styled";
import { useQueryClient } from "@tanstack/react-query";
import { Button, Form, Input, message, Modal, Select, Spin, Typography, Space } from "antd";
import React, { useState } from "react";
import UserSystemForm from "./UserSystemForm";
import { useCreateUserSystem } from "hooks/useAuth";
import { CopyOutlined, CheckOutlined } from "@ant-design/icons";

const { Option } = Select;

const ModalAddUser = ({ refetch }: { refetch: () => void }) => {

  const queryClient = useQueryClient();

  const { mutate, isPending } = useCreateUserSystem();


  const [showModal, setShowModal] = useState<boolean>(false);
  const [showPasswordModal, setShowPasswordModal] = useState<boolean>(false);
  const [createdUserData, setCreatedUserData] = useState<any>(null);
  const [copied, setCopied] = useState<boolean>(false);

  const [formModal] = Form.useForm();

  const onCloseModal = () => {
    formModal.resetFields();
    setShowModal(false);
  };

  const onClosePasswordModal = () => {
    setShowPasswordModal(false);
    setCreatedUserData(null);
    setCopied(false);
  };

  const handleCopyPassword = async () => {
    if (createdUserData?.password) {
      try {
        await navigator.clipboard.writeText(createdUserData.password);
        setCopied(true);
        message.success("คัดลอกรหัสผ่านแล้ว");
        setTimeout(() => setCopied(false), 2000);
      } catch (err) {
        message.error("ไม่สามารถคัดลอกรหัสผ่านได้");
      }
    }
  };

  const onFinishModal = (values: any) => {
    console.log(values);
    mutate({
        first_name: values.first_name.trim(),
        last_name: values.last_name.trim(),
        email: values.email.trim(),
        mobile: values.mobile.trim(),
       // username: values.username.trim() || "",
        image: values.image && values.image.length > 0 ? values.image[0].url : "",
        role_id: values.role_id,
        is_generated_password: false,
        is_otp: true,
        address: {
            line_1: values.line_1.trim(),
            line_2: "",
            province_id: values.province,
            district_id: values.district,
            sub_district_id: values.sub_district,
            post_code: values.zip_code,
        }
    }, {
        onSuccess: async (data) => {
            if(!data.error_message) {
                await queryClient.refetchQueries({
                    queryKey: ["user_system"],
                    type: "active",
                  });
                
                // Store user data and show password modal
               // setCreatedUserData(data);
                refetch();
                onCloseModal();
              //  setShowPasswordModal(true);
                message.success("เพิ่มผู้ใช้งานระบบสำเร็จ");

                formModal.resetFields();
        }else {
            message.error(`เพิ่มผู้ใช้งานระบบไม่สำเร็จ: ${data.error_message}`);
        }

        }
    })
  };

  return (
    <div>
      <Button
        type="primary"
        onClick={() => {
          setShowModal(true);
        }}
        disabled={isPending}
      >
        เพิ่มผู้ใช้งานระบบ
      </Button>
      <Modal
        title="เพิ่มผู้ใช้งานระบบ"
        open={showModal}
        maskClosable={false}
        onCancel={() => {
          onCloseModal();
        }}
        width={800}
        style={{ top: 20 }}
        footer={null}
      >
        <WrapperAll>
          <UserSystemForm form={formModal} onFinish={onFinishModal} isPending={isPending} />
        </WrapperAll>
      </Modal>

      {/* Password Display Modal */}
      <Modal
        title="ข้อมูลผู้ใช้งานที่สร้างเสร็จแล้ว"
        open={showPasswordModal}
        onCancel={onClosePasswordModal}
        footer={[
          <Button key="close" type="primary" onClick={onClosePasswordModal}>
            ปิด
          </Button>
        ]}
        width={500}
      >
        <Space direction="vertical" style={{ width: "100%" }} size="large">
          <div>
            <Typography.Title level={5}>ข้อมูลผู้ใช้งาน:</Typography.Title>
            <Typography.Text strong>ชื่อ: </Typography.Text>
            <Typography.Text>
              {createdUserData?.first_name} {createdUserData?.last_name}
            </Typography.Text>
            <br />
            <Typography.Text strong>Username: </Typography.Text>
            <Typography.Text>{createdUserData?.username}</Typography.Text>
            <br />
            <Typography.Text strong>Email: </Typography.Text>
            <Typography.Text>{createdUserData?.email}</Typography.Text>
          </div>

          <div>
            <Typography.Title level={5}>รหัสผ่านสำหรับเข้าสู่ระบบ:</Typography.Title>
            <PasswordContainer>
              <Input
                value={createdUserData?.password}
                readOnly
                style={{ flex: 1 }}
                type="text"
              />
              <Button
                icon={copied ? <CheckOutlined /> : <CopyOutlined />}
                onClick={handleCopyPassword}
                style={{ marginLeft: 8 }}
                type={copied ? "default" : "primary"}
              >
                {copied ? "คัดลอกแล้ว" : "คัดลอก"}
              </Button>
            </PasswordContainer>
          </div>

          <div style={{ backgroundColor: "#f6ffed", border: "1px solid #b7eb8f", borderRadius: 6, padding: 16 }}>
            <Typography.Text type="success" strong>
              📋 สำคัญ: กรุณาบันทึกรหัสผ่านนี้
            </Typography.Text>
            <br />
            <Typography.Text type="secondary">
              รหัสผ่านนี้จะแสดงเพียงครั้งเดียว กรุณาคัดลอกและส่งให้ผู้ใช้งานเพื่อใช้ในการเข้าสู่ระบบครั้งแรก
            </Typography.Text>
          </div>
        </Space>
      </Modal>
    </div>
  );
};

export default ModalAddUser;

const WrapperAll = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px;
`;

const PasswordContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
